<template>
<q-modal :content-css="{ minWidth: '600px', height: '35vh' }" v-model="showDlg" no-backdrop-dismiss @show="phone = '', patients=[], search_msg = $t('searchresults')">
  <q-modal-layout>
    <q-toolbar slot="header">
      <q-toolbar-title>
        {{$t('selectpatient')}}
      </q-toolbar-title>
      <q-btn
        flat
        round
        @click="closeDlg"
        icon="close"
      />
    </q-toolbar>

    <q-toolbar slot="footer">
      <q-toolbar-title>
      </q-toolbar-title>
      <q-btn
        color="secondary"
        :label="$t('closebtn')"
        @click="closeDlg"
      />
    </q-toolbar>

    <div class="doc-container">
        <div class="col-12" style = "padding:20px;">
          <q-field :label="$t('searchph')" style="font-size:10pt;" :label-width="6" class="q-mb-md">
            <q-input v-model="phone"  prefix="+7" maxlength="15" style = "float:left; width:226px" @keyup.enter="search" />
            <q-btn icon="search" color="primary" @click="search"/>
          </q-field>
          <template v-if="patients.length>0">
            <q-table :data="patients" :columns="columns" row-key="name" hide-bottom  dense>
              <template slot="body" slot-scope="props">
                <q-tr :props="props" >
                  <q-td key="name" :props="props">
                    {{ props.row.name }}
                  </q-td>
                  <q-td key="phone" :props="props">
                    {{ props.row.phone }}
                  </q-td>
                  <q-td key="email" :props="props">
                    {{ props.row.email }}
                  </q-td>
                  <q-td key="select" :props="props">
                    <q-btn label="Выбрать" color="secondary" dense @click="setuser(props.row.phone)"/>
                  </q-td>
                </q-tr>
              </template>
            </q-table>
          </template>
          <template v-else>
            <q-jumbotron>
              <div style="text-align:center">{{ search_msg }}</div>
            </q-jumbotron>
          </template>
        </div>
    </div>
  </q-modal-layout>
</q-modal></template>

<script>

import axios from 'axios'
import VMasker from 'vanilla-masker'

export default {
  data () {
    return {
      phone: '',
      patients: [],
      columns: [
        { name: 'name', label: this.$t('patient'), field: 'name', align: 'left', required:true },
        { name: 'phone', label: this.$t('phone'), field: 'phone', align: 'center' },
        { name: 'email', label: this.$t('email'), field: 'email', align: 'center' },
        { name: 'select', label: '', field: '', align: 'center' },
      ],
      search_msg: this.$t('searchresults')
    }
  },

  props: {
    showDlg: false,
    uuid: '',
  },     

  watch: {
      'phone' (newVal, oldVal) {
        this.phone = VMasker.toPattern(newVal, '(999) 999-99-99')
      }
  },  

  methods:
  {
    setuser: function(phone)
    {
      let request = {
        phone: phone
      }
      const requestStr = JSON.stringify(request)
      axios
        .post(`${this.$root.api_url}device/${this.uuid}/set_patient/`, requestStr, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
          }
      }).then((data) => {
        this.$q.notify({
            message: this.$t('setpatientsucc'),
            type: 'positive',
            icon: 'thumb_up'
        })
        this.closeDlg()
      })
      .catch((e) => {
          console.log(e.response.data)
          switch (e.response.status) {
            case 403: this.$router.push('/auth'); break
            default: this.$q.notify({message: this.$t('errors.setpatienterr'), type: 'negative', icon: 'report_problem' }); break
          }
      })
    },

    search: function()
    {
      let phone = '%2B7' + this.phone.replace(/\D+/g, '')
      axios
        .get(`${this.$root.api_url}patient/?phone=${phone}`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'JWT ' + this.$store.state.token
          }
      }).then((data) => {
        //console.log(data)
        this.patients = []
        if (data.data.length > 0)
          this.patients = data.data
        else
          this.search_msg = this.$t('errors.searcherr')
      })
      .catch((e) => {
          console.log(e.response.data)
          switch (e.response.status) {
            case 403: this.$router.push('/auth'); break
            default: this.$q.notify({message: this.$t('savesettingserr'), type: 'negative', icon: 'report_problem' }); break
          }
      })
    },

    closeDlg:function()
    {
      this.$emit('closeSelectPatientDlg');
    }
  },
  components: {  }

}
</script>
